<template>
	<div class="col-md-12 col-lg-6 col-xl-4 px-0">
		<div class="card class-feature m-2">
			<div class="card-header py-3">
				<span class="h6">Theme Benefit</span>
			</div>
			<div class="card-body p-0">
				<input type="text" class="form-control" v-model="theme.Name" />
				<expanding-textarea>
					<template v-slot:default="{resize}">
						<textarea
						class="form-control"
						@input="resize"
						v-model.lazy="theme.Description"
						></textarea>
					</template>
				</expanding-textarea>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'level',
		'theme',
	],
	watch: {
		theme: {
			deep: true,
			handler: function(value){
				this.$store.commit('setCharacterProp',[
					{
						key: `Levels[${this.level}].Theme`,
						val: value,
					}
				])
			}
		}
	}
}
</script>

<style scoped>
input {
	border-color: transparent;
	border-radius: 0px;
}
textarea {
	border-radius: 0px;
	border-bottom-color: transparent;
	border-left-color: transparent;
	border-right-color: transparent;
	border-bottom-left-radius: 3px;
	border-bottom-right-radius: 3px;
	top: -2px;
}
</style>